import uibModalModule from 'angular-ui-bootstrap/src/modal';

import tpl from './debug-auth.tpl.html';
import normalButtonComponentMod from '../../../common/material-components/buttons/normal-button.component';
import textfieldComponentMod from '../../../common/material-components/textfields/textfield.component';

/**
 * Modal for debug authentication with username and password (not available for normal users)
 */
class DebugAuthModalController {
  constructor($uibModalInstance) {
    'ngInject';

    this.$uibModalInstance = $uibModalInstance;

    this.username = '';
    this.password = '';
  }

  submit() {
    this.$uibModalInstance.close({username: this.username, password: this.password});
  }

  close() {
    this.$uibModalInstance.dismiss();
  }
}

const config = {
  templateUrl: tpl,
  controller: DebugAuthModalController,
  controllerAs: '$ctrl',
  size: 'sm'
};

const mod = angular.module('app.auth.modals.debugAuthModal', [
  uibModalModule,
  normalButtonComponentMod,
  textfieldComponentMod
])

.factory('openDebugAuthModal', function ($uibModal) {
  return () => $uibModal.open(config);
});

export default mod.name;
